import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 获取小佩里面的clientIf的url(前台)
export function getgoodsdetails(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/xpmsg/getWebUrl',
    // url: 'http://192.168.99.13:5000/uims-oauth/xpmsg/getWebUrl',
    method: 'get',
    params
  })
}
// 获取chat(前台)
export function getRmChat(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/xpmsg/getUserId',
    // url: 'http://192.168.99.13:5000/uims-oauth/xpmsg/getUserId',
    method: 'get',
    params
  })
}
// //获取客服信息(前台)
export function rmCustomerService(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/xpmsg/getSender',
    // url: 'http://192.168.99.13:5000/uims-oauth/xpmsg/getSender',
    method: 'get',
    params
  })
}
// //发送配件订单(前台)
export function transmitorder(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/xpmsg/part/sendCommodityInfo',
    // url: 'http://192.168.99.13:5000/wss-part/xpmsg/part/sendCommodityInfo',
    method: 'get',
    params
  })
}
// //发送订单详情订单(前台)
export function sendparticulars(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/xpmsg/order/sendOrderInfo',
    // url: 'http://192.168.99.13:5000/wss-order/xpmsg/order/sendOrderInfo',
    method: 'get',
    params
  })
}
